import { useQuery } from 'react-query';
import { layoffService } from '_services';
import { retryServerErrors, useLayoffMutation } from '../useLayoff';

export const signatureKeys = {
  list: ['layoffs', 'signatures', 'list'],
  count: ['layoffs', 'signatures', 'count'],
  detail: (hash) => ['layoffs', 'signatures', 'detail', hash],
  preview: (hash, draft) => ['layoffs', 'signatures', 'preview', hash, draft],
};

export const useSignatureList = () =>
  useQuery(signatureKeys.list, layoffService.getSignatures);

export const useSignatureCount = () =>
  useQuery(signatureKeys.count, layoffService.getSignatureCount, {
    refetchInterval: 60 * 1000,
    // The nav item simply stays hidden if this fails
    retry: false,
  });

export const useSignatureDetail = (hash) =>
  useQuery(
    signatureKeys.detail(hash),
    () => layoffService.getSignatureDetail(hash),
    { retry: retryServerErrors },
  );

export const useSignaturePreview = (hash, draft, enabled = true) =>
  useQuery(
    signatureKeys.preview(hash, draft),
    () => layoffService.getSignaturePreview({ hash, draft }),
    { enabled, keepPreviousData: true, staleTime: 5 * 60 * 1000 },
  );

export const useSavedSignature = () =>
  useQuery(['user', 'signature'], layoffService.getSavedSignature, {
    staleTime: 5 * 60 * 1000,
  });

export const useSignLayoff = (options) =>
  useLayoffMutation(layoffService.signLayoff, {
    showFieldErrors: true,
    ...options,
  });

export const useRecordRefusalAsSigner = (options) =>
  useLayoffMutation(layoffService.recordRefusalAsSigner, {
    showFieldErrors: true,
    ...options,
  });
